module.exports = __webpack_public_path__ + "img/desktop_person4.83076a48.svg";